import React, { Component } from 'react';
import { Link } from "react-router-dom";
import _ from 'underscore';

import DropdownList from './DropdownList';
import config from './../config';

class SearchResultsDictionaryOverview extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/es/agg/dictionaries/';

		this.state = {
			listData: [],
			selectedItem: ''
		};
	}

	componentDidMount() {
		if (this.props.searchParams.searchString) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.searchParams.searchString != this.props.searchParams.searchString
		) {
			this.fetchData();
		}

		if (prevProps.searchParams.ordabok != this.state.selectedItem) {
			this.setState({
				selectedItem: this.props.searchParams.ordabok
			});
		}
	}

	fetchData() {
		this.setState({
			searchString: this.props.searchParams.searchString,
			selectedItem: ''
		});

		let urlParams = [];
		if (this.props.searchParams.searchString) {
			urlParams.push('ord='+this.props.searchParams.searchString);
		}

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData:json.results,
					/*
					listData: _.sortBy(json.results, function(item) {
						return window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[item.fkdictionary] ? window.ordabankiData.dictionaries[item.fkdictionary] : item.fkdictionary;
					}),
					*/
					resultsCount: json.results.reduce(function(s, f) {
						return s+f.count;
					}, 0),
					prevUrl: json.previous || null,
					nextUrl: json.next || null
				})
			}.bind(this));
	}

	render() {
		let listData;
		let dropdownListData

		let listLengthLimit = 10;

		if (this.state.listData.length > listLengthLimit) {
			listData = this.state.listData.slice(0, listLengthLimit);
			dropdownListData = this.state.listData.slice(listLengthLimit);
		}
		else {
			listData = this.state.listData;
		}

		return (
			<React.Fragment>
				{
					listData.length > 0 && this.props.searchParams.searchString &&
					<React.Fragment>

						<ol className="breadcrumb">
							<li className="breadcrumb-item active" aria-current="page">Leitarorð: <strong>{this.props.searchParams.searchString}</strong></li>
						</ol>

						<div className={'nav nav-pills'} style={
							{
								position: 'relative',
								marginBottom: 10,
								zIndex: 1
							}
						}>

							<span className="nav-item">
								<Link to={'/leit/'+this.props.searchParams.searchString} 
								onClick={function() {
									this.setState({
										selectedItem: ''
									})
								}.bind(this)}
								className={'nav-link'+(!this.state.selectedItem ? ' active' : '')}>
									Öll orðasöfn ({this.state.resultsCount})
								</Link>
							</span>

							{
								listData.map(function(item, index) {
									return <span key={index} className="nav-item">
										<Link to={'/leit/'+this.props.searchParams.searchString+'/ordabok/'+item.fkdictionary} 
											onClick={function() {
												this.setState({
													selectedItem: item.fkdictionary
												})
											}.bind(this)}
											className={'nav-link'+(this.state.selectedItem == item.fkdictionary ? ' active' : '')}>
											{window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[item.fkdictionary] ? window.ordabankiData.dictionaries[item.fkdictionary] : item.fkdictionary} ({item.count})
										</Link>
									</span>;
								}.bind(this))
							}

							{
								dropdownListData &&
								<DropdownList selectedItem={this.state.selectedItem} 
									valueField={'fkdictionary'} 
									labelFunc={function(item) {
										return (window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[item.fkdictionary] ? window.ordabankiData.dictionaries[item.fkdictionary] : item.fkdictionary)+' ('+item.count+')';
									}} 
									linkFormatFunc={function(item) {
										return '/leit/'+this.props.searchParams.searchString+'/ordabok/'+item.fkdictionary
									}.bind(this)} 
									listData={dropdownListData} 
									label={'Fleiri orðasöfn ('+dropdownListData.length+')'}
								/>
							}

						</div>

					</React.Fragment>
				}
			</React.Fragment>
		);
	}
}

export default SearchResultsDictionaryOverview;



// WEBPACK FOOTER //
// ./src/components/SearchResultsDictionaryOverview.js